import Loader from '../Loader'

export const FullScreenLoading = () => {
  return (
    <div className="w-100 vh-100 d-flex justify-content-center align-items-center">
      <Loader />
    </div>
  )
}
